/**
 * @generated SignedSource<<4a1ed70d2e64c946a0ac7a066d5812f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type salesChannelCheckSellerPlanQuery$variables = Record<PropertyKey, never>;
export type salesChannelCheckSellerPlanQuery$data = {
  readonly checkSellerPlan: {
    readonly canSubscribeToNewPlan: boolean;
    readonly currentProductCount: number;
    readonly isLegacyPlan: boolean;
    readonly isProductLimitReached: boolean;
    readonly maxProductsGrow: number | null;
    readonly maxProductsScale: number | null;
  };
};
export type salesChannelCheckSellerPlanQuery = {
  response: salesChannelCheckSellerPlanQuery$data;
  variables: salesChannelCheckSellerPlanQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SellerPlanCheck",
    "kind": "LinkedField",
    "name": "checkSellerPlan",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isLegacyPlan",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isProductLimitReached",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxProductsGrow",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxProductsScale",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentProductCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "canSubscribeToNewPlan",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelCheckSellerPlanQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "salesChannelCheckSellerPlanQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "4320c2c8286ee1b193e5e70e6842f1b3",
    "id": null,
    "metadata": {},
    "name": "salesChannelCheckSellerPlanQuery",
    "operationKind": "query",
    "text": "query salesChannelCheckSellerPlanQuery {\n  checkSellerPlan {\n    isLegacyPlan\n    isProductLimitReached\n    maxProductsGrow\n    maxProductsScale\n    currentProductCount\n    canSubscribeToNewPlan\n  }\n}\n"
  }
};
})();

(node as any).hash = "787a343d2a38dccb5f9859272744bdf0";

export default node;
